import React, {useEffect, useState} from 'react';
import {AppBar, Box, ButtonBase, FormControlLabel, SvgIcon, Switch, Toolbar, useMediaQuery} from "@mui/material";
import localStrings from "../../localStrings";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { keyframes } from '@emotion/react';

function BoardAddAppBar({reorganizeActive, setReorganizeActive, setAddGraphOpened, chartBoardsItems}) {

    const pulse = keyframes`
      0% { transform: scale(1); }
      50% { transform: scale(1.3); }
      100% { transform: scale(1); }
    `;

    const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));

    return (
      <AppBar
          classes='none'
          position="sticky"
          style={{
              top: "60px",
              border: "none",
              boxShadow: "none",
              backdropFilter: lgUp ? 'blur(8px)' : 'none',
          }}
          color="transparent">

          <Toolbar>
              <div style={{
                  width: '100%'

              }}>
                  <Box sx={{display: 'flex'}}>
                      <Box sx={{flexGrow: 1}}/>

                      {lgUp &&
                      <tooltip title={localStrings.reorderGraphInDashBoardActivate}>
                          <Box sx={{marginRight: 2}}>

                              <FormControlLabel
                                  control={(
                                      <Switch
                                          checked={reorganizeActive}
                                          edge="start"
                                          name="direction"
                                          onChange={() => {
                                              setReorganizeActive(!reorganizeActive)
                                          }}
                                      />
                                  )}
                                  label={localStrings.reorderGraphInDashBoardActivate}
                              />

                          </Box>
                      </tooltip>
                      }

                      <tooltip title={localStrings.addGraphToDashBoard}>
                          <Box>

                              <ButtonBase
                                  onClick={() => {
                                      setAddGraphOpened(true)
                                  }}
                                  sx={{
                                      backgroundColor: 'primary.main',
                                      borderRadius: '50%',
                                      color: 'primary.contrastText',
                                      p: '12px',
                                      animation: !lgUp && chartBoardsItems.length === 0
                                          ? `${pulse} 1.2s ease-in-out infinite`
                                          : 'none',
                                      transformOrigin: 'center',
                                  }}
                              >
                                  <SvgIcon>
                                      <AddCircleOutlineIcon/>
                                  </SvgIcon>
                              </ButtonBase>
                          </Box>
                      </tooltip>
                  </Box>
              </div>
          </Toolbar>

      </AppBar>
  )
}

export default BoardAddAppBar